import {cn} from "@/lib/utils";
import type {AdminStatusTone} from "./adminStatus";
import {orderStatusTone, statusToneFromVariant} from "./adminStatus";

type Props = {
  children: React.ReactNode;
  tone?: AdminStatusTone;
  /** Legacy order status number → tone */
  status?: number;
  /** Map AdminBadge-like variants */
  variant?: "default" | "secondary" | "success" | "warning" | "danger" | "outline" | "pending" | "draft" | "processing" | "delivered";
  className?: string;
};

export function AdminStatusBadge({children, tone, status, variant, className}: Props) {
  const resolved: AdminStatusTone =
    tone ??
    (status !== undefined ? orderStatusTone(status) : undefined) ??
    (variant ? statusToneFromVariant(variant) : "draft");

  return (
    <span className={cn("admin-status-badge", `admin-status-badge--${resolved}`, className)}>
      {children}
    </span>
  );
}
